import { FC } from "react";
import type { WheelRaffleParticipant } from "../model/types";
import { formatRaffleDate } from "./formatRaffleDate";
import { RaffleUserCell } from "./RaffleUserCell";

import styles from "./RaffleTable.module.css";

interface Props {
  participants: WheelRaffleParticipant[];
  // Сквозная нумерация между страницами.
  offset?: number;
}

// fid — публичный ID аккаунта, тот же, что в профиле.
export const ParticipantsTable: FC<Props> = ({ participants, offset = 0 }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <th>#</th>
        <th>User ID</th>
        <th>Joined</th>
        <th className={styles.numeric}>Volume, USDT</th>
      </tr>
    </thead>
    <tbody>
      {participants.map((participant, index) => (
        <tr key={participant.fid}>
          <td className={styles.index}>{offset + index + 1}</td>
          <td>
            <RaffleUserCell fid={participant.fid} />
          </td>
          <td>{formatRaffleDate(participant.joined_at)}</td>
          <td className={styles.numeric}>{participant.volume_usdt_at_join}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
